import { WS_OFF, WS_ON } from "@/lib/workSample";
export const EDITABLE = [
  "title", "department", "location", "employment_type", "practice_area", "law_firm", "pqe_min", "pqe_max", "bar_required", "jd_text", "summary", "seniority", "requirements",
  "ideal_profile", "interview_config", "assessment_config", "work_sample_config", "experience_config", "scoring_weights",
  "resume_subweights", "thresholds", "blind_mode", "wizard_step",
];

export const WEIGHT_KEYS = [
  ["resume", "Resume match", "How well the resume matches the confirmed requirements."],
  ["experience", "Experience", "Relevant years and seniority of past roles."],
  ["personality", "Personality assessment", "Closeness to the ideal trait ranges for this role."],
  ["interview", "AI interview", "Scores from the structured AI interview."],
  ["work_sample", "Work sample", "Score from a practical task, if enabled."],
];

export const SUBWEIGHT_KEYS = [
  ["work_experience", "Relevant Work Experience", "Relevance, PQE and seniority of past legal roles."],
  ["academic", "Academic Record", "Degrees, institution, grades and class."],
  ["publications", "Publication and Research", "Articles, papers, journal pieces and research work."],
  ["achievements", "Achievements and Recognitions", "Includes awards, rankings (Chambers, Legal 500), moot court results, scholarships and academic ranks."],
];
export const SUBWEIGHT_DEFAULTS = { work_experience: 40, academic: 25, publications: 15, achievements: 20 };

const round2 = (n) => Math.round(n * 100) / 100;
export const weightsTotal = (w = {}) => round2(Object.values(w).reduce((a, b) => a + Number(b || 0), 0));
export const weightsValid = (w) => Math.abs(weightsTotal(w) - 1) < 0.001;
export const subTotal = (s = {}) => Object.values(s).reduce((a, b) => a + Number(b || 0), 0);

export function normalizeWeights(w) {
  const total = weightsTotal(w);
  if (!total) return w;
  const out = Object.fromEntries(Object.entries(w).map(([k, v]) => [k, round2(Number(v || 0) / total)]));
  const residual = round2(1 - weightsTotal(out));
  if (residual) {
    const top = Object.entries(out).sort((a, b) => b[1] - a[1])[0][0];
    out[top] = round2(out[top] + residual);
  }
  return out;
}

const STAGE_DEFAULT = { personality: 0.15, interview: 0.35, work_sample: 0.15 };

export function toggleStage(job, stage, on) {
  if (stage === "work_sample") {
    const cur = job.scoring_weights || {};
    const old = on ? WS_OFF : WS_ON;
    const isDefault = Object.keys(old).every((k) => Math.abs((cur[k] || 0) - old[k]) < 0.001);
    return { ...job, work_sample_config: { ...job.work_sample_config, enabled: on },
      scoring_weights: isDefault ? { ...(on ? WS_ON : WS_OFF) } : normalizeWeights({ ...cur, work_sample: on ? 0.15 : 0 }) };
  }
  const w = { ...job.scoring_weights, [stage]: on ? STAGE_DEFAULT[stage] : 0 };
  const next = { ...job, scoring_weights: normalizeWeights(w) };
  if (stage === "personality") next.assessment_config = { ...job.assessment_config, personality_enabled: on };
  if (stage === "interview") next.interview_config = { ...job.interview_config, enabled: on };
  if (stage === "work_sample") next.work_sample_config = { ...job.work_sample_config, enabled: on };
  return next;
}

export function editablePayload(job) {
  const p = {};
  EDITABLE.forEach((k) => { if (job[k] !== undefined) p[k] = job[k]; });
  if (p.scoring_weights && !weightsValid(p.scoring_weights)) delete p.scoring_weights;
  if (p.resume_subweights && subTotal(p.resume_subweights) !== 100) delete p.resume_subweights;
  return p;
}
